/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBarberShiftStart200, PostApiBarberShiftStart400, PostApiBarberShiftStart401, PostApiBarberShiftStart403, PostApiBarberShiftStart404, PostApiBarberShiftStart500, PostApiBarberShiftStartMutationRequest, PostApiBarberShiftStartMutationResponse } from "../entities/PostApiBarberShiftStart";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsShiftSchema } from "./models/shiftSchema";
import { modelsShiftStartInputSchema } from "./models/shiftStartInputSchema";
import { z } from "zod/v4";

/**
 * @description OK
 */
export const postApiBarberShiftStart200Schema = z.lazy(() => modelsShiftSchema) as unknown as z.ZodType<PostApiBarberShiftStart200>

/**
 * @description Bad Request
 */
export const postApiBarberShiftStart400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStart400>

/**
 * @description Unauthorized
 */
export const postApiBarberShiftStart401Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStart401>

/**
 * @description Forbidden
 */
export const postApiBarberShiftStart403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStart403>

/**
 * @description Not Found
 */
export const postApiBarberShiftStart404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStart404>

/**
 * @description Internal Server Error
 */
export const postApiBarberShiftStart500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBarberShiftStart500>

/**
 * @description ID рабочего места и время окончания
 */
export const postApiBarberShiftStartMutationRequestSchema = z.lazy(() => modelsShiftStartInputSchema) as unknown as z.ZodType<PostApiBarberShiftStartMutationRequest>

export const postApiBarberShiftStartMutationResponseSchema = z.lazy(() => postApiBarberShiftStart200Schema) as unknown as z.ZodType<PostApiBarberShiftStartMutationResponse>